import { render } from "./InvitationList.vue?vue&type=template&id=2d8ed868&scoped=true"
import script from "./InvitationList.vue?vue&type=script&lang=js"
export * from "./InvitationList.vue?vue&type=script&lang=js"

import "./InvitationList.vue?vue&type=style&index=0&id=2d8ed868&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ed868"]])

export default __exports__